import React from 'react';
import PropTypes from 'prop-types';
import DefaultPage from 'Containers/DefaultPage';
import HeroHeader from 'Components/HeroHeader/deprecated';
import ServiceBox from './ServiceBox';
import ServiceCategoryModel from 'Stores/ServiceCategoryModel';
import { withRouter } from 'react-router-dom';
import { withUrlParams } from 'Utils/withUrlParams';
import styles from './styles.scss';
import { MODAL_TYPES } from 'Containers/ContactForm/contactFormConstants';
import { exchangeLabelIfNecessary, exchangeTrackingLabelIfNecessary } from 'Utils/getButtonLabel';
import { getAdjustedModalType } from 'Utils/getModalType';
import cn from 'classnames';
import ConsumptionData from 'Components/ConsumptionData';
import { Col, Container, Row } from 'Components/Grid';

class ServiceDetails extends React.Component {
  static propTypes = {
    serviceCategory: PropTypes.object,
    onOpenContact: PropTypes.func,
    setSharedState: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      serviceCategory: new ServiceCategoryModel(props.serviceCategory),
    };
  }

  openModal = (targetModaltype) => {
    this.props.updateMultipleUrlQuery({
      modaltype: targetModaltype,
      showmodal: 'true',
    });
  };

  getModalType = (modalType) => {
    if (modalType === 'OSB') {
      return MODAL_TYPES.ONLINE_SERVICE_BOOKING.name;
    } else {
      return MODAL_TYPES.SERVICE_REQUEST.name;
    }
  };

  onContactClick = (modalType) => {
    this.openModal(this.getModalType(modalType));
  };

  UNSAFE_componentWillMount() {
    const { serviceCategory } = this.state;
    const serviceFootnotes = serviceCategory.getFootnotes();
    this.props.setSharedState('serviceFootnotes', serviceFootnotes);
  }

  render() {
    const { serviceCategory } = this.state;
    const serviceFootnotes = serviceCategory.getFootnotes();
    const { isOsbUser, isSalesPartner, isServicePartner } = window.dealer.settings;
    const withLegalForReifenservice = serviceCategory.slug === 'reifenservice';

    return (
      <DefaultPage>
        <HeroHeader
          small
          image={serviceCategory.image}
          title={serviceCategory.name}
          subtitle="Service"
          introtext={serviceCategory.description}
          backlink="/service/werkstatt/uebersicht"
        />
        {withLegalForReifenservice && (
          <div className={styles.root}>
            <Container>
              <Row>
                <Col>
                  <div className={cn(styles.legalWrapper)}>
                    <strong className={styles.upperCase}>Informationen zum EU-Reifenlabel</strong>
                    <p>
                      Das EU-Reifenlabel hilft Ihnen dabei, umweltbewusste und fundierte
                      Entscheidungen beim Reifenkauf zu treffen. Erfahren Sie mehr über verfügbare
                      Reifen für unsere Mazda-Modelle sowie über die entsprechenden
                      Qualitätskriterien. Mit Klick auf den Link gelangen Sie auf die
                      Informationsseite der Mazda Motors (Deutschland) GmbH.
                    </p>
                    <a
                      href="https://www.mazda.de/eu-reifenlabel/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Klicke hier um mehr über Reifenlabels zu erfahren - öffnet in neuem Tab oder Fenster"
                    >
                      Mehr erfahren
                    </a>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        )}
        <div className={styles.bg}>
          {serviceCategory.services.map((service, index) => {
            const footnote = serviceFootnotes
              .filter((note) => note.serviceId === service.id)
              .shift();
            const adjustedModalType = getAdjustedModalType({
              isOsbUser,
              isSalesPartner,
              isServicePartner,
              initialModalType: this.getModalType(service.modalType),
            });

            return (
              <div key={`service-${service.id}`}>
                <ServiceBox
                  headline={service.name}
                  description={service.description}
                  price={service.price}
                  priceText={service.priceText}
                  priceType={service.priceType}
                  scopes={service.scopes}
                  benefits={service.benefits}
                  onContactClick={() => this.onContactClick(service.modalType)}
                  footnote={footnote}
                  consumptionText={service.consumptionText}
                  buttonLabel={exchangeLabelIfNecessary('Termin vereinbaren', adjustedModalType)}
                  trackingLabel={exchangeTrackingLabelIfNecessary(undefined, adjustedModalType)}
                />
              </div>
            );
          })}
        </div>
      </DefaultPage>
    );
  }
}

export default withRouter(withUrlParams(ServiceDetails));
